import React from "react";
import styled, { keyframes } from "styled-components";

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.0);
  } 40% {
    transform: scale(1.0);
  }
`;

const LoadingStyles = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  text-align: center;

  .spinner-dot {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -9px;
    margin-left: 13px;
    width: 18px;
    height: 18px;
    background-color: #fff;
    border-radius: 100%;
    display: inline-block;
    animation: ${bounce} 1.4s infinite ease-in-out;
    animation-fill-mode: both;

    &:nth-child(1) {
      margin-left: -31px;
      animation-delay: -0.32s;
    }
    &:nth-child(2) {
      margin-left: -9px;
      animation-delay: -0.16s;
    }
  }
`;

export default function Loading() {
  return (
    <LoadingStyles>
      <div className="spinner-dot" />
      <div className="spinner-dot" />
      <div className="spinner-dot" />
    </LoadingStyles>
  );
}



// WEBPACK FOOTER //
// ./src/common/Loading.js